import { os } from '@utils/device-utils';
import AcMarquee from 'ac-components/ac-marquee';
import classnames from 'classnames';
import { useTranslation } from 'hooks/use-translation';
import React, { FC } from 'react';
import styles from './styles.scss';



const OutcomeSection: FC<any> = (props) => {
	const { marqueeRef } = props;
	const { transData, list } = useTranslation('happyKids.outcome');
	const cardList = (listArray: typeof list[0]) => {
		if (list.length == 0) return []
		return listArray.map((item: { id: string; img: string | undefined; title: boolean | React.ReactChild | React.ReactFragment | React.ReactPortal | null | undefined; span: boolean | React.ReactChild | React.ReactFragment | React.ReactPortal | null | undefined; context: boolean | React.ReactChild | React.ReactFragment | React.ReactPortal | null | undefined }, index: React.Key | undefined) => {
			return (
				<div
					key={index}
					className={classnames('li-item', styles['li-item'], styles['li-item-' + item.id])}
				>
					<img src={item.img} alt="" />
					<div className={styles['li-item-title']}>{item.title}</div>
					<div className={styles['li-item-context']}>
						<span>{item.span}</span>
						<span>{item.context}</span>
					</div>
				</div>
			)
		})

	}

	return (
		<section className={styles['ac-outcome']}>
			<div className={styles['ac-outcome-container']}>
				<h1><span>{transData.title}</span></h1>
				<div className={styles['ac-outcome-marquee']}>
					<div dangerouslySetInnerHTML={{ __html: transData.en }} />
					<div className={classnames(styles['ac-outcome-box'], styles['ac-outcome-box-1'])}>
						<AcMarquee ref={marqueeRef} order={'desc'}>{cardList(list[0])}</AcMarquee>
					</div>
				</div>
				<div className={styles['ac-outcome-marquee']}>
					<div dangerouslySetInnerHTML={{ __html: transData.math }} />
					<div className={classnames(styles['ac-outcome-box'], styles['ac-outcome-box-2'])}>
						<AcMarquee ref={marqueeRef} order={'asc'}>{cardList(list[1])}</AcMarquee>
					</div>
				</div>
			</div>
		</section >
	);
}

export default OutcomeSection
